import { IconType } from "react-icons/lib";
import { TbBriefcase, TbCrown, TbGlassChampagne, TbUser, TbUserStar } from "react-icons/tb";

import { softColors } from "./colors";

export enum PassengerTransferType {
    STANDARD = 1, // Standard patient transfer
    VIP, // VIP patient with premium services
    DELUXE, // Deluxe room and enhanced experience
    STAFF, // Company staff transfer
    SPECIAL_GUEST, // Special guest or VIP visitor
}
export const PassengerTransferTypeLabel: Record<PassengerTransferType, string> = {
    [PassengerTransferType.STANDARD]: "Normal",
    [PassengerTransferType.VIP]: "VIP",
    [PassengerTransferType.DELUXE]: "Deluxe",
    [PassengerTransferType.STAFF]: "Personel",
    [PassengerTransferType.SPECIAL_GUEST]: "Özel Misafir",
} as const;

export type PassengerTransferTypeItem = {
    component: () => IconType;
    label: string;
    hover: string;
    bg: string;
    text: string;
    tooltip: {
        title: string;
        description: string;
    };
    value: PassengerTransferType;
};

export const passengerTransferTypes: PassengerTransferTypeItem[] = [
    {
        component: () => TbUser,
        label: PassengerTransferTypeLabel[PassengerTransferType.STANDARD],
        tooltip: {
            title: "Normal hasta",
            description: "Standart hizmetlerle seyahat eden hasta.",
        },
        ...softColors.brown,
        value: PassengerTransferType.STANDARD,
    },
    {
        component: () => TbCrown,
        label: PassengerTransferTypeLabel[PassengerTransferType.VIP],
        tooltip: {
            title: "VIP hasta (VIP-Angebot)",
            description: "Premium hizmetler ve öncelikli destek ile özel erişim sunulacak kişi.",
        },
        ...softColors.amber,
        value: PassengerTransferType.VIP,
    },
    {
        component: () => TbGlassChampagne,
        label: PassengerTransferTypeLabel[PassengerTransferType.DELUXE],
        tooltip: {
            title: "Deluxe Oda",
            description: "Geliştirilmiş ve ekstra ayrıcalıklarla daha zengin bir deneyim sunulacak kişi.",
        },
        ...softColors.purple,
        value: PassengerTransferType.DELUXE,
    },
    {
        component: () => TbBriefcase,
        label: PassengerTransferTypeLabel[PassengerTransferType.STAFF],
        tooltip: {
            title: "Şirket Personeli",
            description: "Elit Klinik bünyesinde çalışan personel ve çalışanlar için özel transfer hizmeti.",
        },
        ...softColors.blue,
        value: PassengerTransferType.STAFF,
    },
    {
        component: () => TbUserStar,
        label: PassengerTransferTypeLabel[PassengerTransferType.SPECIAL_GUEST],
        tooltip: {
            title: "Özel Misafir",
            description: "Özel davetli misafirler ve VIP ziyaretçiler için ayrıcalıklı transfer hizmeti.",
        },
        ...softColors.green,
        value: PassengerTransferType.SPECIAL_GUEST,
    },
];

export const passengerTransferTypeOptions: { label: string; value: string }[] = passengerTransferTypes.map((item) => ({
    label: item.label,
    value: item.value.toString(),
}));
